import twclsx from 'utils/twclsx';

/**
 * OrderBanner component displays a banner with customizable styling.
 *
 * @param {Object} props - Component props
 * @param {boolean} [props.bold=true] - Whether to apply bold font weight
 * @param {boolean} [props.centered=false] - Whether to center align the content
 * @param {React.ReactNode} props.children - The content to display in the banner (required)
 * @param {boolean} [props.extendToCardEdges=false] - Whether to extend the banner to the edges of a Card component (applies negative margins and width calculation)
 * @param {'error'|'lime'|'mango'|'grey'} [props.variant='mango'] - The color variant of the banner
 * @returns {JSX.Element} The rendered OrderBanner component
 */
function OrderBanner({
    bold = true,
    centered = false,
    children,
    className,
    extendToCardEdges = false,
    variant = 'mango',
}) {
    return (
        <span
            className={twclsx(
                'text-body-xs block w-full rounded-tl-lg rounded-tr-lg px-20 py-5 lg:px-30',
                { 'font-grotesk-bold': bold },
                { 'bg-error/50': variant === 'error' },
                { 'bg-lime': variant === 'lime' },
                { 'bg-mango': variant === 'mango' },
                { 'bg-grey-light': variant === 'grey' },
                {
                    'relative -mx-20 -mt-20 mb-20 w-[calc(100%+2.5rem)] lg:-mx-30 lg:-mt-30 lg:w-[calc(100%+3.75rem)]':
                        extendToCardEdges,
                },
                className
            )}
        >
            <span className={twclsx('flex items-center gap-5', { 'justify-center': centered })}>{children}</span>
        </span>
    );
}

export default OrderBanner;
